import { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import BannerSection from "../../Components/BannerSection";
import FixturesAndResults from "../../Components/FixturesAndResults";
import axios from "axios";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Champions from "../../Components/Champions";
import Navbar from "./navbar";
import Dropdown from "./Dropdown";
import useDeviceType from "../../Utiles/FindDevice";
import LeagueList from "./LeagueList";
import {
  fetchRoundPageCategory,
  fixtureOpen,
  updateV2Fixtures,
  fetchRoundToJoinData,
} from "./roundToJoin.slice";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BuyTokenPopUp from "../../popups/BuyTokenPopup";
import TokenRedeemPopUp from "../../popups/tokenRedeemPopUp";
import { baseURL } from "../../services/axiosConfig";
import { refreshTokenV2 } from "../../services/api";
import Footer from "../../Components/Footer";

const CircularLoader = () => (
  <div className="flex flex-col items-center justify-center py-8">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mb-4"></div>
    <div className="text-blue-500 font-medium">Data fetching...</div>
  </div>
);

export default function RoundToJoin() {
  const { redeemPopup } = useSelector((state) => state.roundToJoin);
  const token = localStorage.getItem("access_token");
  const location = useLocation();
  const { myRound } = location.state || {};
  const pageCategory = useSelector((state) => state.roundToJoin.pageCategory);
  const deviceType = useDeviceType();

  const [selectedNav, setSelectedNav] = useState("Rounds");
  const [selectedSubNav, setSelectedSubNav] = useState(pageCategory);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [otherMenusOpen, setOtherMenusOpen] = useState(false);
  const [dropdownPos, setDropdownPos] = useState({});

  const [sportLeague, setSprotLeage] = useState({
    sport: [],
    league: [],
    roundState: [],
  });

  const [roundDropdownOpen, setRoundDropdownOpen] = useState([
    { id: 1, label: "Active Round", value: "active" },
  ]);

  const [selectedGame, setSelectedGame] = useState({
    sport: {},
    league: {},
    roundState: {},
  });

  const { roundToJoinPotData } = useSelector(
    (state) => state.roundToJoin
  );

  const [selectedRounds, setSelectedRounds] = useState();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setSelectedSubNav(pageCategory);
  }, [pageCategory]);

  const profileBtnRef = useRef(null);

  useEffect(() => {
    if (dropdownOpen && profileBtnRef.current) {
      profileBtnRef.current.getBoundingClientRect();
      setDropdownPos({ right: 0 });
    }
  }, [dropdownOpen]);

  const [fixturesData, setFixturesData] = useState([]);

  // ✅ Guest-safe auth headers
  const getAuthHeaders = () => {
    if (token && token !== "null" && token !== "undefined") {
      try {
        return { Authorization: `Bearer ${JSON.parse(token)}` };
      } catch {
        return {};
      }
    }
    return {};
  };

  const fetchFixtures = async (roundId, potInfo, matchWeeks, pickId, component) => {
    try {
      if (component === "mypot") {
        const res = await axios.get(
          `${baseURL}/pot/pickmatchpredictions/${matchWeeks}?pick=${pickId}`,
          { headers: getAuthHeaders() }
        );
        dispatch(updateV2Fixtures(res.data));
      } else {
        const res = await axios.get(
          `${baseURL}/pot/fixtures?league=${potInfo.season}&season=${potInfo.season_year}&matchweek=${potInfo.pot_current_matchweek}`,
          { headers: getAuthHeaders() }
        );
        dispatch(updateV2Fixtures(res.data));
      }
    } catch (error) {
      if (error?.response?.status === 401 && token) {
        refreshTokenV2(dispatch);
      }
      console.log(error);
    }
  };

  // ✅ Guests allowed except mypot
  const viewFixtureHandler = (roundId, potInfo, matchWeeks, pickId, component) => {
    const hasToken = token && token !== "null" && token !== "undefined";

    if (component === "mypot" && !hasToken) {
      navigate("/login");
      return;
    }

    fetchFixtures(roundId, potInfo, matchWeeks, pickId, component);
    dispatch(fixtureOpen(true));
  };

  const myPickHandler = () => {};

  useEffect(() => {
  const hasValidToken =
    token && token !== "null" && token !== "undefined";

  // 🔥 Guests should ALWAYS see Round To Join
  if (!hasValidToken) {
    dispatch(fetchRoundPageCategory("Round To Join"));
    return;
  }

  // 🔐 Logged users logic remains same
  if (myRound) {
    dispatch(fetchRoundPageCategory("myRound"));
  } else if (myRound === false && pageCategory === "compleated") {
    dispatch(fetchRoundPageCategory("compleated"));
  } else {
    dispatch(fetchRoundPageCategory("Round To Join"));
  }
}, [myRound, token]);

useEffect(() => {
  const fetchPublicRounds = async () => {
    try {
      const res = await axios.get(
        `${baseURL}/dashboard/rounds/prioritized-retrieve/?type=newpot`
      );

      dispatch(
        fetchRoundToJoinData({
          roundToJoinPot: res?.data?.data || [],
        })
      );
    } catch (error) {
      console.error("Error fetching public rounds:", error);
    }
  };

  fetchPublicRounds();
}, []);

useEffect(() => {
  if (
    Array.isArray(roundToJoinPotData) &&
    roundToJoinPotData.length > 0
  ) {
    const sportsFromRounds = [];

    roundToJoinPotData.forEach((round) => {
      round?.pots?.forEach((pot) => {
        if (pot?.game_id && pot?.game_name) {
          sportsFromRounds.push({
            id: pot.game_id,
            name: pot.game_name,
          });
        }
      });
    });

    const uniqueSports = Array.from(
      new Map(sportsFromRounds.map((s) => [s.id, s])).values()
    );

    setSprotLeage((prev) => ({
      ...prev,
      sport: uniqueSports,
    }));
  }
}, [roundToJoinPotData]);



  const fetchSportList = async () => {
  try {
    const hasValidToken =
      token && token !== "null" && token !== "undefined";

    const headers = {};

    if (hasValidToken) {
      headers.Authorization = `Bearer ${JSON.parse(token)}`;
    }

    const res = await axios.get(
      `${baseURL}/dashboard/rounds/games/`,
      { headers }
    );

    setSprotLeage((prev) => ({
      ...prev,
      sport: res?.data?.data || [],
    }));
  } catch (error) {
    if (error?.response?.status === 401 && token) {
      refreshTokenV2(dispatch);
    }
    console.error("Error fetching sports:", error);
  }
};

  const fetchLeagueList = async () => {
  try {
    const hasValidToken =
      token && token !== "null" && token !== "undefined";

    const headers = {};

    if (hasValidToken) {
      headers.Authorization = `Bearer ${JSON.parse(token)}`;
    }

    const url = selectedGame?.sport?.id
      ? `${baseURL}/pot/leagues/dropdown/?game_id=${selectedGame.sport.id}`
      : `${baseURL}/pot/leagues/dropdown/`;

    const res = await axios.get(url, { headers });

    setSprotLeage((prev) => ({
      ...prev,
      league: res?.data || [],
    }));
  } catch (error) {
    if (error?.response?.status === 401 && token) {
      refreshTokenV2(dispatch);
    }
    console.error("Error fetching leagues:", error);
  }
};


  useEffect(() => {
    fetchSportList();
  }, []);

  useEffect(() => {
    fetchLeagueList();
  }, [selectedGame?.sport?.id]);

  return (
    <div className="font-interFont w-full bg-[#082642] min-h-screen border border-[#082642]">
      {redeemPopup && <TokenRedeemPopUp />}

      <Navbar
        setDropdownOpen={setDropdownOpen}
        dropdownOpen={dropdownOpen}
        dropdownPos={dropdownPos}
        selectedNav={selectedNav}
        setSelectedNav={setSelectedNav}
        setDropdownPos={setDropdownPos}
        otherMenusOpen={otherMenusOpen}
        setOtherMenusOpen={setOtherMenusOpen}
      />

      <ToastContainer position="top-right" autoClose={3000} />

      <div className="pt-16 w-full min-h-screen">
        <div className="w-full bg-gradient-to-r from-[#007FFF] to-[#00C05B] py-4 px-2 overflow-x-auto scrollbar-hide">
          <div className="flex items-center gap-3 px-1 lg:px-4 whitespace-nowrap">
            <button
              className={`px-3 py-1 rounded-full font-archivo font-semibold ${
                selectedSubNav === "Round To Join"
                  ? "bg-white text-black"
                  : "border border-[#FFFFFF70] text-[#FFFFFF70]"
              }`}
              onClick={() => {
                setSelectedSubNav("Round To Join");
                dispatch(fetchRoundPageCategory("Round To Join"));
              }}
            >
              Rounds To Join
            </button>

            {token && token !== "null" && (
              <>
                <button
                  className={`px-3 py-1 rounded-full font-archivo font-semibold ${
                    selectedSubNav === "myRound"
                      ? "bg-white text-black"
                      : "border border-[#FFFFFF70] text-[#FFFFFF70]"
                  }`}
                  onClick={() => {
                    setSelectedSubNav("myRound");
                    dispatch(fetchRoundPageCategory("myRound"));
                  }}
                >
                  My Rounds
                </button>

                <button
                  className={`px-3 py-1 rounded-full font-archivo font-semibold ${
                    selectedSubNav === "compleated"
                      ? "bg-white text-black"
                      : "border border-[#FFFFFF70] text-[#FFFFFF70]"
                  }`}
                  onClick={() => {
                    setSelectedSubNav("compleated");
                    dispatch(fetchRoundPageCategory("compleated"));
                  }}
                >
                  Completed Rounds
                </button>
              </>
            )}
          </div>
        </div>

        <div className={`${deviceType === "mobile" ? "bg-white" : ""}`}>
          {selectedSubNav === "Round To Join" && <BannerSection />}

          <div className="w-full bg-white sm:w-[95%] mx-auto p-2 sm:p-4 md:p-8 rounded mt-4">
            <LeagueList
              deviceType={deviceType}
              viewFixtureHandler={viewFixtureHandler}
              myPickHandler={myPickHandler}
              fixturesData={fixturesData}
              selectedSubNav={selectedSubNav}
              sportLeague={sportLeague}
              setSelectedGame={setSelectedGame}
              data={roundDropdownOpen}
              selectedGame={selectedGame}
              setSelectedRounds={setSelectedRounds}
              selectedRounds={selectedRounds}
            />
          </div>
        </div>
      </div>

      <Footer componnent="rules" />
    </div>
  );
}
